// extracted by mini-css-extract-plugin
export var paginationContainer = "_67-0";